import React from 'react';
import '../App.css';
import '../styles/HomeRoom.css';
import { Grid2 as Grid, Typography } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

export default function HomeRoom() {
	const { ref: titleRef, inView: titleInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: subtitleRef, inView: subtitleInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: aSuiteRef, inView: aSuiteInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: bSuiteRef, inView: bSuiteInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: doubleRef, inView: doubleInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: queenRef, inView: queenInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: kingRef, inView: kingInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	const { ref: otaLogosRef, inView: otaLogosInView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});

	return (
		<div id="rooms">
			<Typography
				ref={titleRef}
				className={`${titleInView ? 'animate__animated animate__fadeInUp' : ''}`}
				variant="h3"
				fontWeight="bold"
				align="center"
				gutterBottom
				sx={{
					mt: { xs: 0, sm: 1, md: 2 },
					mb: 1
				}}
			>
				Our Rooms
			</Typography>
			<div
				ref={subtitleRef}
				className={`heading-two ${subtitleInView ? 'animate__animated animate__fadeInUp' : ''}`}
			>
				Unwind in our comfortable rooms after a busy day of activities
			</div>
			<div className="div-block-19">
				<div className="collection-list-wrapper">
					<div role="list" className="collection-list">
						<div
							role="listitem"
							ref={aSuiteRef}
							className={`roomslistitem ${aSuiteInView ? 'animate__animated animate__fadeInUp animate__slow' : ''}`}
							style={{
								backgroundImage:
									'url("https://cdn.prod.website-files.com/61ba3a6450bc5c2511332956/61ba3a6450bc5ce520332965_1.jpg")',
							}}
						>
							<Link
								to="/room/queen-suite-a"
								className="link-block"
							>
								<div>
									<div className="text-block-4">
										Queen Suite A
									</div>
									<div className="text-block-9">
										Queen bed + sofa bed, dining area, and
										kitchenette
									</div>
								</div>
							</Link>
						</div>
						<div
							role="listitem"
							ref={bSuiteRef}
							className={`roomslistitem ${bSuiteInView ? 'animate__animated animate__fadeInUp animate__slow' : ''}`}
							style={{
								backgroundImage:
									'url("https://cdn.prod.website-files.com/61ba3a6450bc5c2511332956/61ba3a6450bc5c5d9a332969_1.jpg")',
							}}
						>
							<Link
								to="/room/queen-suite-b"
								className="link-block"
							>
								<div>
									<div className="text-block-4">
										Queen Suite B
									</div>
									<div className="text-block-9">
										Two Queen beds, dining space, and
										kitchenette
									</div>
								</div>
							</Link>
						</div>
						<div
							role="listitem"
							ref={doubleRef}
							className={`roomslistitem ${doubleInView ? 'animate__animated animate__fadeInUp animate__slow' : ''}`}
							style={{
								backgroundImage:
									'url("https://cdn.prod.website-files.com/61ba3a6450bc5c2511332956/61ba3a6450bc5c4be9332959_1.jpg")',
							}}
						>
							<Link to="/room/double-room" className="link-block">
								<div>
									<div className="text-block-4">
										Double Room
									</div>
									<div className="text-block-9">
										Two double beds plus kitchenette
									</div>
								</div>
							</Link>
						</div>
						<div
							role="listitem"
							ref={queenRef}
							className={`roomslistitem ${queenInView ? 'animate__animated animate__fadeInUp animate__slow' : ''}`}
							style={{
								backgroundImage:
									'url("https://cdn.prod.website-files.com/61ba3a6450bc5c2511332956/657207c8345387ef977ffa11_Queen%20beds%20lower%20floor.jpg")',
								backgroundPosition: '0 100%',
								backgroundSize: 'cover',
							}}
						>
							<Link
								to="/room/standard-queen"
								className="link-block"
							>
								<div>
									<div className="text-block-4">
										Standard Queen
									</div>
									<div className="text-block-9">
										Quiet Queen room with kitchenette
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className="collection-list-wrapper-copy">
						<div role="list" className="collection-list-copy">
							<div
								role="listitem"
								ref={kingRef}
								className={`roomslistitem-copy ${kingInView ? 'animate__animated animate__fadeInUp animate__slow' : ''}`}
								style={{
									backgroundImage:
										'url("https://cdn.prod.website-files.com/61ba3a6450bc5c2511332956/61ba3a6450bc5c35b0332961_1.jpg")',
									backgroundPosition: '0 100%',
									backgroundSize: 'cover',
								}}
							>
								<Link
									to="/room/king-deluxe"
									className="link-block-copy"
								>
									<div>
										<div className="text-block-4">
											King Deluxe
										</div>
										<div className="text-block-9">
											Spacious King room with a sofa and
											full kitchenette
										</div>
									</div>
								</Link>
							</div>
							<div
								role="listitem"
								ref={otaLogosRef}
								className={`ota-logos-room ${otaLogosInView ? 'animate__animated animate__fadeInUp' : ''}`}
							>
								<a
									href="https://live.ipms247.com/booking/book-rooms-426634"
									className="book-now-in-home-room"
									target="_blank"
									rel="noopener noreferrer"
								>
									BOOK NOW
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
